import { useSelector } from "react-redux";
import { IState } from "../../store";

export const useShowContactUsForm = () => useSelector((state: IState) => state.contactUs.showForm);